import React from 'react';
import { H1, H2, H3, Text, Card, Icon, Button } from '@blueprintjs/core';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

class Dashboard extends React.Component {
  navigateTo = (path) => {
    this.props.history.push(path);
  };

  render() {
    const { authStore } = this.props;
    
    return (
      <div style={{ 
        display: 'flex',
        minHeight: 'calc(100vh - 64px)',
        backgroundColor: 'var(--bg-primary)', 
        color: 'var(--text-primary)'
      }}>
         {/* Left Half - Welcome Section */}
         <div style={{ 
           flex: 1,
           display: 'flex',
           flexDirection: 'column',
           justifyContent: 'center',
           alignItems: 'center',
           padding: 'var(--v3-spacing-xxl)',
           position: 'relative',
           background: `
             radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.1) 0%, transparent 50%),
             radial-gradient(circle at 80% 20%, rgba(16, 185, 129, 0.1) 0%, transparent 50%),
             radial-gradient(circle at 40% 40%, rgba(139, 92, 246, 0.05) 0%, transparent 50%),
             linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-surface) 100%)
           `,
           overflow: 'hidden'
         }}>
           {/* Subtle Surgery-related Background Elements */}
           <div style={{
             position: 'absolute',
             top: '10%',
             left: '5%',
             fontSize: '120px',
             color: 'rgba(59, 130, 246, 0.03)',
             transform: 'rotate(-15deg)',
             userSelect: 'none',
             pointerEvents: 'none'
           }}>
             ✚
           </div>
           <div style={{
             position: 'absolute',
             top: '20%',
             right: '10%',
             fontSize: '80px',
             color: 'rgba(16, 185, 129, 0.03)',
             transform: 'rotate(25deg)',
             userSelect: 'none',
             pointerEvents: 'none'
           }}>
             ⚕
           </div>
           <div style={{
             position: 'absolute',
             bottom: '15%',
             left: '15%',
             fontSize: '100px',
             color: 'rgba(139, 92, 246, 0.03)',
             transform: 'rotate(45deg)',
             userSelect: 'none',
             pointerEvents: 'none'
           }}>
             🏥
           </div>
           <div style={{
             position: 'absolute',
             bottom: '25%',
             right: '5%',
             fontSize: '90px',
             color: 'rgba(245, 158, 11, 0.03)',
             transform: 'rotate(-30deg)',
             userSelect: 'none',
             pointerEvents: 'none'
           }}>
             🔬
           </div>

           {/* Welcome Content - 70% width */}
           <div style={{ 
             textAlign: 'center',
             zIndex: 1,
             position: 'relative',
             width: '70%',
             maxWidth: '600px'
           }}>
             <div style={{ 
               display: 'flex', 
               alignItems: 'center', 
               justifyContent: 'center',
               marginBottom: 'var(--v3-spacing-lg)',
               gap: 'var(--v3-spacing-md)'
             }}>
               <span style={{ 
                 fontSize: '48px',
                 color: 'var(--primary)',
                 fontFamily: 'var(--v3-font-family-sans)',
                 fontWeight: 'var(--v3-font-weight-bold)'
               }}>✃</span>
            <H1 style={{ 
              color: 'var(--text-primary)', 
              margin: 0, 
              fontSize: 'var(--v3-font-size-6xl)', 
              fontWeight: 'var(--v3-font-weight-bold)', 
              fontFamily: 'var(--v3-font-family-sans)',
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--v3-spacing-md)'
            }}>
              NewChart
              <span style={{ 
                color: 'var(--text-secondary)',
                fontSize: 'var(--v3-font-size-4xl)',
                fontWeight: 'var(--v3-font-weight-normal)'
              }}>|</span>
              Ridley
            </H1>
             </div>
             
            <H2 style={{ 
              color: 'var(--text-primary)', 
              margin: 'var(--v3-spacing-lg) 0', 
              fontSize: 'var(--v3-font-size-5xl)', 
              fontWeight: 'var(--v3-font-weight-semibold)', 
              fontFamily: 'var(--v3-font-family-sans)'
            }}>
              Welcome, {authStore.name}!
            </H2>
             
             <Text style={{ 
               color: 'var(--text-secondary)', 
               fontSize: 'var(--v3-font-size-xl)', 
               margin: 0, 
               fontFamily: 'var(--v3-font-family-sans)',
               lineHeight: 1.6
             }}>
               Your comprehensive surgery management platform is ready to streamline your workflow
             </Text>
           </div>
         </div>

         {/* Right Half - Workflow Actions */}
         <div style={{ 
           flex: 1,
           padding: 'var(--v3-spacing-xxl)',
           display: 'flex',
           flexDirection: 'column',
           gap: 'var(--v3-spacing-xl)',
           backgroundColor: 'var(--sidebar-bg)',
           borderLeft: '1px solid var(--sidebar-border)'
         }}>
           {/* Workflow Actions Section */}
           <div>
             <H3 style={{ 
               color: 'var(--nav-text-color)', 
               marginBottom: 'var(--v3-spacing-lg)', 
               fontSize: 'var(--v3-font-size-3xl)', 
               fontWeight: 'var(--v3-font-weight-bold)', 
               fontFamily: 'var(--v3-font-family-sans)'
             }}>
               Workflows
             </H3>
             
             <div style={{ 
               display: 'flex',
               flexDirection: 'column',
               gap: 'var(--v3-spacing-sm)'
             }}>
               {/* Branchwise Calendar */}
               <div
                 onClick={() => this.navigateTo('/v3/workflow/sx-calendar-branchwise')}
                 onKeyDown={(e) => {
                   if (e.key === "Enter" || e.key === " ") {
                     e.preventDefault();
                     this.navigateTo('/v3/workflow/sx-calendar-branchwise');
                   }
                 }}
                 role="button"
                 tabIndex={0}
                 className="v3-nav-item"
                 style={{
                   fontSize: 'var(--v3-font-size-xl)',
                   fontWeight: 'var(--v3-font-weight-medium)',
                   minHeight: '60px',
                   padding: 'var(--v3-spacing-lg)',
                   margin: '0 var(--v3-spacing-sm)',
                   borderRadius: 'var(--v3-border-radius-md)',
                   borderLeft: '3px solid transparent'
                 }}
               >
                 <Icon icon="timeline-events" size={24} className="v3-nav-item-icon" />
                 <span>Branchwise Calendar</span>
               </div>

               {/* Doctorwise Calendar */}
               <div
                 onClick={() => this.navigateTo('/v3/workflow/doctorwise-calendar')}
                 onKeyDown={(e) => {
                   if (e.key === "Enter" || e.key === " ") {
                     e.preventDefault();
                     this.navigateTo('/v3/workflow/doctorwise-calendar');
                   }
                 }}
                 role="button"
                 tabIndex={0}
                 className="v3-nav-item"
                 style={{
                   fontSize: 'var(--v3-font-size-xl)',
                   fontWeight: 'var(--v3-font-weight-medium)',
                   minHeight: '60px',
                   padding: 'var(--v3-spacing-lg)',
                   margin: '0 var(--v3-spacing-sm)',
                   borderRadius: 'var(--v3-border-radius-md)',
                   borderLeft: '3px solid transparent'
                 }}
               >
                 <Icon icon="calendar" size={24} className="v3-nav-item-icon" />
                 <span>Doctorwise Calendar</span>
               </div>

               {/* Surgery Booking */}
               <div
                 onClick={() => this.navigateTo('/v3/workflow/surgery-booking')}
                 onKeyDown={(e) => {
                   if (e.key === "Enter" || e.key === " ") {
                     e.preventDefault();
                     this.navigateTo('/v3/workflow/surgery-booking');
                   }
                 }}
                 role="button"
                 tabIndex={0}
                 className="v3-nav-item"
                 style={{
                   fontSize: 'var(--v3-font-size-xl)',
                   fontWeight: 'var(--v3-font-weight-medium)',
                   minHeight: '60px',
                   padding: 'var(--v3-spacing-lg)',
                   margin: '0 var(--v3-spacing-sm)',
                   borderRadius: 'var(--v3-border-radius-md)',
                   borderLeft: '3px solid transparent'
                 }}
               >
                 <Icon icon="cut" size={24} className="v3-nav-item-icon" />
                 <span>Surgery Booking</span>
               </div>
             </div>
           </div>

           {/* Monthly Surgery Statistics */}
           <div>
             <H3 style={{ 
               color: 'var(--nav-text-color)', 
               marginBottom: 'var(--v3-spacing-lg)', 
               fontSize: 'var(--v3-font-size-2xl)', 
               fontWeight: 'var(--v3-font-weight-semibold)', 
               fontFamily: 'var(--v3-font-family-sans)'
             }}>
               This Month's Statistics
             </H3>
             
             <div style={{ 
               display: 'grid',
               gridTemplateColumns: 'repeat(2, 1fr)',
               gap: 'var(--v3-spacing-md)'
             }}>
               <Card style={{ 
                 background: 'var(--sidebar-bg)', 
                 border: '1px solid var(--sidebar-border)',
                 borderRadius: 'var(--v3-border-radius-lg)',
                 padding: 'var(--v3-spacing-lg)',
                 textAlign: 'center'
               }}>
                 <Icon icon="calendar" size={32} color="var(--primary-color)" style={{ marginBottom: 'var(--v3-spacing-sm)' }} />
                 <Text style={{ 
                   fontSize: 'var(--v3-font-size-3xl)',
                   fontWeight: 'var(--v3-font-weight-bold)',
                   color: 'var(--nav-text-color)',
                   display: 'block',
                   margin: '0 0 var(--v3-spacing-xs) 0'
                 }}>47</Text>
                 <Text style={{ fontSize: 'var(--v3-font-size-sm)', color: 'var(--text-secondary)', margin: 0 }}>
                   Total Surgeries
                 </Text>
               </Card>

               <Card style={{ 
                 background: 'var(--sidebar-bg)', 
                 border: '1px solid var(--sidebar-border)',
                 borderRadius: 'var(--v3-border-radius-lg)',
                 padding: 'var(--v3-spacing-lg)',
                 textAlign: 'center'
               }}>
                 <Icon icon="person" size={32} color="var(--success)" style={{ marginBottom: 'var(--v3-spacing-sm)' }} />
                 <Text style={{ 
                   fontSize: 'var(--v3-font-size-3xl)',
                   fontWeight: 'var(--v3-font-weight-bold)',
                   color: 'var(--nav-text-color)',
                   display: 'block',
                   margin: '0 0 var(--v3-spacing-xs) 0'
                 }}>12</Text>
                 <Text style={{ fontSize: 'var(--v3-font-size-sm)', color: 'var(--text-secondary)', margin: 0 }}>
                   Cataract Surgeries
                 </Text>
               </Card>

               <Card style={{ 
                 background: 'var(--sidebar-bg)', 
                 border: '1px solid var(--sidebar-border)',
                 borderRadius: 'var(--v3-border-radius-lg)',
                 padding: 'var(--v3-spacing-lg)',
                 textAlign: 'center'
               }}>
                 <Icon icon="cut" size={32} color="var(--warning)" style={{ marginBottom: 'var(--v3-spacing-sm)' }} />
                 <Text style={{ 
                   fontSize: 'var(--v3-font-size-3xl)',
                   fontWeight: 'var(--v3-font-weight-bold)',
                   color: 'var(--nav-text-color)',
                   display: 'block',
                   margin: '0 0 var(--v3-spacing-xs) 0'
                 }}>8</Text>
                 <Text style={{ fontSize: 'var(--v3-font-size-sm)', color: 'var(--text-secondary)', margin: 0 }}>
                   Retinal Surgeries
                 </Text>
               </Card>

               <Card style={{ 
                 background: 'var(--sidebar-bg)', 
                 border: '1px solid var(--sidebar-border)',
                 borderRadius: 'var(--v3-border-radius-lg)',
                 padding: 'var(--v3-spacing-lg)',
                 textAlign: 'center'
               }}>
                 <Icon icon="time" size={32} color="var(--error)" style={{ marginBottom: 'var(--v3-spacing-sm)' }} />
                 <Text style={{ 
                   fontSize: 'var(--v3-font-size-3xl)',
                   fontWeight: 'var(--v3-font-weight-bold)',
                   color: 'var(--nav-text-color)',
                   display: 'block',
                   margin: '0 0 var(--v3-spacing-xs) 0'
                 }}>3.2</Text>
                 <Text style={{ fontSize: 'var(--v3-font-size-sm)', color: 'var(--text-secondary)', margin: 0 }}>
                   Avg. Duration (hrs)
                 </Text>
               </Card>
             </div>
           </div>
         </div>
      </div>
    );
  }
}

export default inject('authStore')(observer(withRouter(Dashboard)));